export default __webpack_public_path__ + "static/media/SPPL-Financial-Statements-March-2025.1dc43bf8.pdf";